import { showNotification } from '@ingeniorforeningen/figurine-core';
import { Errors } from '../types';
import { stripText } from './textsHelpers';

export const truncateFilename = (filenameString: string, len: number = 15) => {
  const nameLength = filenameString.length;
  if (nameLength > len) {
    const section = len * 0.5;
    return (
      filenameString.substring(0, len - section - 3) +
      '...' +
      filenameString.substring(filenameString.length - section, filenameString.length)
    );
  }
  return filenameString;
  // }
};

export const FileErrorAlert = (
  fileName: string,
  DropzoneErrorCodes: string,
  errorTexts: Errors,
) => {
  type DropzoneErrorCodesTranslateType = { [key: string]: string };
  const DropzoneErrorCodesTranslate: DropzoneErrorCodesTranslateType = {
    'file-too-large': stripText(errorTexts.fileTooLargeError),
    'file-invalid-type': stripText(errorTexts.badRequestError),
    'too-many-files': stripText(errorTexts.fileLimitReachedError),
  };
  showNotification({
    title:
      DropzoneErrorCodesTranslate[DropzoneErrorCodes as keyof DropzoneErrorCodesTranslateType] ??
      'Fejl ved upload',
    text: `${fileName}`,
    type: 'error',
  });
};
